/* eslint-disable import/prefer-default-export */
const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export const updateDobStatus = async ({ matchedCaseId, sourceCaseId, status }) => {
  if (!matchedCaseId || !sourceCaseId) {
    throw new Error('Invalid matchedCaseId or sourceCaseId');
  }

  window.dispatchEvent(new Event('api-activity'));
  const url = new URL(`${getEnv('REACT_APP_AGENTIC_API_BASE_URL')}/dob_status_update`);
  url.searchParams.append('source_case_id', sourceCaseId);
  url.searchParams.append('matched_case_id', matchedCaseId);
  url.searchParams.append('status', status);

  const headers = {
    code: getEnv('REACT_APP_AGENTIC_API_CODE'),
    'x-functions-key': getEnv('REACT_APP_AGENTIC_API_FUNCTION_KEY'),
  };

  try {
    const res = await fetch(url.toString(), { method: 'PATCH', headers });
    if (!res.ok) throw new Error('Failed to update DOB Status');
    return res.json();
  } catch (error) {
    throw new Error('Network error while updating DOB Status');
  }
};
